export const mgmType = {
  GET_MGM_LIST_REQUEST: "GET_PROMO_CODE_REQUEST",
  GET_MGM_LIST_SUCCESS: "GET_PROMO_CODE_SUCCESS",
  GET_MGM_LIST_FAIL: "GET_PROMO_CODE_FAIL"
};
